<template>
    <main>
      <!-- Growth and Accomplishment section -->
      <div class="md:px-12 max-w-screen-2xl mx-auto bg-[#D5CBB8]">
        <div class="py-20">
          <h1 class="text-center text-lg font-bold">Growth & Accomplishments</h1>
          <p class="text-center mt-4">
            "...because anything less than 100% is not enough." Barka U. Mshelia
          </p>
        </div>
      </div>
  
      <!-- Slider implementation with carousel -->
      <div class="md:px-12 max-w-screen-2xl mx-auto bg-black py-12">
        <div id="default-carousel" class="relative" data-carousel="slide">
          <!-- Carousel wrapper -->
          <div class="relative overflow-hidden rounded-lg lg:py-10" data-carousel-item>
            <!-- Carousel container -->
            <div
              class="flex transition-transform duration-700 ease-in-out"
              :style="{ transform: `translateX(-${activeIndex * (100 / cardsPerSlide)}%)` }"
            >
              <!-- Awards - 8 total -->
              <div v-for="(award, index) in awards" :key="index" class="min-w-[25%] text-center"> <!-- Each card takes up 25% of the width -->
                <img
                  :src="award.img"
                  class="mx-auto w-32 h-32 rounded-full"
                  :alt="award.alt"
                />
                <p class="mt-4 text-2xl text-white font-bold">{{ award.year }}</p>
                <p class="text-white">{{ award.title }}</p>
              </div>
            </div>
          </div>
  
          <!-- Slider controls -->
          <button
            type="button"
            class="absolute top-1/2 left-0 transform -translate-y-1/2 z-30 flex items-center justify-center h-10 w-10 bg-gray-700 hover:bg-gray-900 rounded-full"
            @click="prevSlide"
          >
            <svg
              class="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            type="button"
            class="absolute top-1/2 right-0 transform -translate-y-1/2 z-30 flex items-center justify-center h-10 w-10 bg-gray-700 hover:bg-gray-900 rounded-full"
            @click="nextSlide"
          >
            <svg
              class="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  export default {
    data() {
      return {
        activeIndex: 0,
        cardsPerSlide: 4, // 4 cards per slide
        totalSlides: Math.ceil(8 / 2), // 8 awards, 2 cards per slide
        awards: [
          {
            img: require("../assets/images/mshel-club.jpeg"),
            year: "2022",
            title: "African Genius Award",
            alt: "African Genius Award",
          },
          {
            img: require("../assets/images/mshel-club.jpeg"),
            year: "2021",
            title: "Titans of Africa, Dubai",
            alt: "Titans of Africa",
          },
          {
            img: require("../assets/images/mshel-club.jpeg"),
            year: "2021",
            title: "Golden Key Award",
            alt: "Golden Key Award",
          },
          {
            img: require("../assets/images/about-barka.jpeg"),
            year: "2020, 2021",
            title: "Best Impact Investment Firm",
            alt: "Best Impact Investment Firm",
          },
          {
            img: require("../assets/images/mshel-club.jpeg"),
            year: "2019",
            title: "Global Investor Award",
            alt: "Global Investor Award",
          },
          {
            img: require("../assets/images/about-barka.jpeg"),
            year: "2018",
            title: "Best African Entrepreneur",
            alt: "Best African Entrepreneur",
          },
          {
            img: require("../assets/images/mshel-club.jpeg"),
            year: "2017",
            title: "Social Impact Award",
            alt: "Social Impact Award",
          },
          {
            img: require("../assets/images/about-barka.jpeg"),
            year: "2016",
            title: "Leadership Award",
            alt: "Leadership Award",
          },
        ],
        slideInterval: null, // To store interval for automatic sliding
      };
    },
    mounted() {
      // Set up automatic slide change every 3 seconds
      this.slideInterval = setInterval(this.nextSlide, 3000);
    },
    beforeDestroy() {
      // Clear the interval when the component is destroyed
      clearInterval(this.slideInterval);
    },
    methods: {
      nextSlide() {
        if (this.activeIndex < this.totalSlides - 1) {
          this.activeIndex++;
        } else {
          this.activeIndex = 0; // Go back to the first set of slides
        }
      },
      prevSlide() {
        if (this.activeIndex > 0) {
          this.activeIndex--;
        } else {
          this.activeIndex = this.totalSlides - 1; // Go to the last set of slides
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .carousel-wrapper {
    display: flex;
    transition: transform 0.5s ease-in-out;
  }
  </style>
  